import UserSettingsModel from 'models/UserSettingsModel';

UserSettingsStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  UserSettingsStore.dispatchCallback,
);

UserSettingsStore.onSettingsLoaded = function (data, response) {
  const settings = data.models[0].present();
  UserSettingsStore.settings = settings;
  UserSettingsStore.trigger('user:settings:load:success', settings);
};

UserSettingsStore.updateErrorCallback = function (data) {};

UserSettingsStore.updateSuccessCallback = function (data) {
  UserSettingsStore.trigger('user:settings:update:success', data.models[0].present().data);
};

UserSettingsStore.onSettingsError = function (error) {
  UserSettingsStore.trigger('user:settings:load:error');
};

UserSettingsStore.acceptTOSCallback = function(data) {
  UserSettingsStore.trigger('user:settings:tos:accepted');
}

UserSettingsStore.on('change', (data) => {
  UserSettingsStore.trigger('user:settings:change:reload', data.present());
});

UserSettingsStore.getSettings = function () {
  let data = {};
  this.models.map((d) => {
    if (d.present().data.settings) {
      data = d.present().data.settings;
    }
  });
  return data;
};
